import { ORDER_SERVICE_ORIGINS } from 'constants/_types/OrderServiceOrigins';

export const SERVICE_ORIGINS_REQUIRING_HOURS_RANGE = [
  ORDER_SERVICE_ORIGINS.TELECONSULTATION,
  ORDER_SERVICE_ORIGINS.TESTS,
  ORDER_SERVICE_ORIGINS.HOME_VISIT,
  ORDER_SERVICE_ORIGINS.SERVICES,
];
